import { COLOR_VALUES } from "shared/config/colors";
import HStack from "shared/components/layout/stack/HStack";
import Text from "shared/components/data-display/text/Text";
import VStack from "shared/components/layout/stack/VStack";
import styled from "styled-components";

export const StyledTitleText = styled(Text)`
    padding-top: 16px;
    padding-bottom: 16px;
`;

export const ListWrapper = styled(HStack)`
    padding: 16px 0 0;
    gap: 10px;
    border-bottom: 1px solid ${COLOR_VALUES.Gray_6};

    label {
        align-items: inherit;
    }
`;

export const ListMainBlock = styled(VStack)`
    border-bottom: 1px solid ${COLOR_VALUES.Gray_4};
`;

export const Wrapper = styled(VStack)`
    width: 100%;
    min-height: 436px;
    background: ${COLOR_VALUES.White};
    border-top: 1px solid ${COLOR_VALUES.Gray_4};

    ${ListMainBlock} ${ListWrapper}:last-child {
        border-bottom: none;
    }

    ${ListMainBlock}:last-child {
        border-bottom: none;

        ${ListMainBlock}:last-child ${ListWrapper} {
            border-bottom: 1px solid ${COLOR_VALUES.Gray_6};
        }
    }
`;

export const ListContent = styled(VStack)`
    flex-grow: 1;
`;
